import * as React from 'react';
import * as _ from 'underscore';

import { CommonStyles } from '../../common/react/CommonStyles';
import { DeprecatedReactMenu } from '../../common/react/components/Menu';
import { HeaderStyles } from './HeaderStyles';

export class HeaderMenuButton extends React.PureComponent<HeaderMenuButton.Props, any> {

  static displayName = 'HeaderMenuButton';

  static element = React.createFactory(HeaderMenuButton);

  public render() {

    const highlight = this.props.hovered || this.props.menuOpen;

    const menuButtonStyle: any = {
      display: 'block',
      height: HeaderStyles.TopBarHeight,
      lineHeight: HeaderStyles.TopBarLineHeight,
      fontFamily: CommonStyles.Fonts.HeaderFont,
      fontSize: CommonStyles.Sizes.HeaderFontSize,
      letterSpacing: HeaderStyles.LetterSpacing,
    };

    // Add icon
    if (this.props.iconPath) {
      // using icon path reduces flickering of icons
      _.extend(menuButtonStyle, this.props.style, {height: '24px'});
      const wrappingDivStyle = {...CommonStyles.Layout.FlexBlockVerticalCenter, height: HeaderStyles.TopBarHeight};

      return (
        <>
          <div style={wrappingDivStyle}>
            <img src={this.props.iconPath} style={menuButtonStyle} alt={this.props.altText || ''} />
          </div>
        </>
      );

    } else if (this.props.iconUrl) {
      _.extend(menuButtonStyle, {
        paddingLeft: 24,
        backgroundImage: this.props.iconUrl,
        backgroundPosition: 'left center',
        backgroundRepeat: 'no-repeat',
        backgroundSize: '24px 24px',
      });
    }

    // Apply style overrides
    _.extend(menuButtonStyle, this.props.style);

    return React.createElement('span', { style: menuButtonStyle }, this.props.label);
  }
}

export module HeaderMenuButton {

  export interface Props extends DeprecatedReactMenu.ButtonProps {
    iconUrl?: string;         // The icon (if any) to display
    label?: string;           // The button's label
    style?: any;              // Style to apply to the header button (overrides defaults)
    iconPath?: string;        // The icon path if want to use an img tag instead of background-image
    altText?: string;         // The alt text for the icon. Only used if iconPath is provided
  }

}
